import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const CoinQuest = () => {
  const navigate = useNavigate();
  const [score, setScore] = useState(0);
  const [question, setQuestion] = useState(null);
  const [userAnswer, setUserAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [coinsCollected, setCoinsCollected] = useState(0);

  const generateQuestion = () => {
    const types = [
      { q: "You have NRs. 575 and spend NRs. 250. How much is left?", a: 325 },
      { q: "3 pencils cost NRs. 75 each. Total cost?", a: 225 },
      { q: "You have NRs. 1000 and buy items for NRs. 345 and NRs. 280. Change?", a: 375 },
      { q: "NRs. 850 + NRs. 425 = ?", a: 1275 },
      { q: "NRs. 1500 - NRs. 735 = ?", a: 765 },
      { q: "4 notebooks at NRs. 150 each. Total?", a: 600 },
      { q: "You have NRs. 2000 and spend NRs. 1275. Change?", a: 725 },
      { q: "5 pens at NRs. 120 each. Total?", a: 600 },
      { q: "NRs. 2550 - NRs. 1825 = ?", a: 725 },
      { q: "You buy 2 items: NRs. 450 and NRs. 375. Total?", a: 825 },
      { q: "NRs. 3000 - NRs. 1460 = ?", a: 1540 },
      { q: "6 erasers at NRs. 50 each. Total?", a: 300 },
    ];
    const q = types[Math.floor(Math.random() * types.length)];
    setQuestion(q);
    setUserAnswer('');
    setFeedback('');
  };

  useEffect(() => {
    generateQuestion();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!question) return;

    const answer = parseFloat(userAnswer);
    if (Math.abs(answer - question.a) < 0.01) {
      setScore(score + 10);
      setCoinsCollected(coinsCollected + 1);
      setFeedback('✅ Correct!');
      setTimeout(generateQuestion, 1500);
    } else {
      setFeedback(`❌ Wrong! Answer: $${question.a.toFixed(2)}`);
      setTimeout(generateQuestion, 2500);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-400 via-yellow-500 to-orange-500 py-8 px-4">
      <div className="max-w-3xl mx-auto">
        <div className="bg-white/10 backdrop-blur-md rounded-xl p-6 mb-6 text-white">
          <div className="flex justify-between items-center">
            <button onClick={() => navigate('/games')} className="hover:text-yellow-900">← Back</button>
            <h1 className="text-3xl font-bold">🪙 Coin Quest</h1>
            <div className="text-2xl font-bold">{score} pts</div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-2xl p-8">
          <div className="text-center mb-8">
            <div className="text-6xl mb-4">💰</div>
            <h2 className="text-2xl font-bold text-gray-800">Money Math!</h2>
            <p className="text-gray-600">Coins Collected: {coinsCollected}</p>
          </div>

          {question && (
            <div className="text-center">
              <div className="text-xl font-bold text-yellow-700 mb-6">{question.q}</div>
              <form onSubmit={handleSubmit} className="max-w-md mx-auto">
                <div className="relative">
                  <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-3xl text-gray-500">$</span>
                  <input
                    type="number"
                    step="0.01"
                    value={userAnswer}
                    onChange={(e) => setUserAnswer(e.target.value)}
                    className="w-full text-3xl text-center border-4 border-yellow-300 rounded-lg p-4 pl-12 mb-4 focus:border-yellow-500 focus:outline-none"
                    placeholder="0.00"
                    autoFocus
                  />
                </div>
                <button type="submit" className="w-full bg-yellow-600 text-white text-xl font-bold py-4 rounded-lg hover:bg-yellow-700">
                  Submit
                </button>
              </form>
              {feedback && (
                <div className={`mt-4 text-xl font-bold ${feedback.includes('✅') ? 'text-green-600' : 'text-red-600'}`}>
                  {feedback}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CoinQuest;